import React from 'react'

import ArgonTypography from 'components/ArgonTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import ArgonBox from "components/ArgonBox";
import Card from "@mui/material/Card";
import Footer from "examples/Footer";
import { ConfirmationNumber, CloudUpload } from '@mui/icons-material';
// MUI Components
import {CardContent,} from "@mui/material";
import { useState,useEffect } from "react";
import {Grid } from "@mui/material";
import ArgonInput from 'components/ArgonInput';
import Dropdown from 'components/CustomDropdown/Dropdown';
import ArgonButton from 'components/ArgonButton';

function AddTicket() {

   const [formData, setFormData] = useState({
      name: "",
      phone: "",
      email: "",
      designation: "",
      password: "",
      profileImage: null,
    });
  
    const handleChange = (e) => {
      const { name, value, files } = e.target;
      setFormData({
        ...formData,
        [name]: files ? files[0] : value,
      });
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      console.log("Form Data:", formData);
    };

    //files show after the image is uploaded

    const [files, setFiles] = useState({ 1: null, 2: null, 3: null });

const handleFileChange = (e, num) => {
  const file = e.target.files[0];
  if (file) {
    setFiles((prev) => ({ ...prev, [num]: file.name }));
  }
};

    //Dropdown k liye
    const [priority, setPriority] = useState("")
    const [supportType, setSupportType] = useState("");
    const [relatedTo, setRelatedTo] = useState("");
    const [status, setStatus] = useState("");

  return (
     <DashboardLayout>
      <DashboardNavbar />

     <ArgonBox p={2}>
  <Card
    sx={{
      borderRadius: "12px",
      backgroundColor: "white", 
      boxShadow: "0 4px 20px rgba(0,0,0,0.06)", 
      border: "1px solid #f0f0f0",
    }}
  >
    {/* Header */}
    <ArgonBox
      sx={{
        p: 2,
        borderBottom: "1px solid #f0f0f0",
      }}
    >
      <ArgonBox display="flex" alignItems="center" gap={1.5}>
        <ConfirmationNumber sx={{ color: "#1976d2", fontSize: "24px" }} />
        <ArgonBox>
          <ArgonTypography variant="h6" fontWeight="medium" color="text.primary">
            Create New Support Ticket
          </ArgonTypography>
          <ArgonTypography variant="body2" color="text.secondary">
            Submit your issue and get help from our support team
          </ArgonTypography>
        </ArgonBox>
      </ArgonBox>
    </ArgonBox>

    {/* Body */}
    <CardContent sx={{ p: 2 }}>
      <form>
        <Grid container spacing={2}>
          {/* Basic Information Section */}
          <Grid item xs={12}>
            <ArgonBox>
              <ArgonTypography variant="h5" color='text' fontWeight="medium" mb={0.5}>
                Basic Information
              </ArgonTypography>
            </ArgonBox>
          </Grid>

          {/* Subject */}
          <Grid item xs={12} md={6}>
            <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={0.5}>
              Subject
            </ArgonTypography>
            <ArgonInput
              fullWidth
              name="subject"
              placeholder="Enter ticket subject"
              variant="outlined"
              size="medium"
            />
          </Grid>

          {/* Contact No */}
          <Grid item xs={12} md={6}>
            <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={0.5}>
              Contact No
            </ArgonTypography>
            <ArgonInput
              fullWidth
              name="contactNo"
              placeholder="Enter Contact No"
              variant="outlined"
              size="medium"
            />
          </Grid>

          {/* Message */}
          <Grid item xs={12}>
            <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={0.5}>
              Message Description
            </ArgonTypography>
            <ArgonInput
              fullWidth
              name="complaint"
              placeholder="Describe your issue..."
              multiline
              rows={3}
              variant="outlined"
            />
          </Grid>

          {/* Ticket Configuration */}
          <Grid item xs={12}>
            <ArgonBox mb={1} mt={1}>
              <ArgonTypography variant="subtitle1" fontWeight="medium" color="text" mb={0}>
                Ticket Configuration
              </ArgonTypography>
            </ArgonBox>
          </Grid>

          {/* Priority */}
          <Grid item xs={12} md={4}>
            <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={0.5}>
              Priority
            </ArgonTypography>
            <Dropdown
              value={priority}
              options={["High", "Medium", "Low"]}
              onChange={(e) => setPriority(e.target.value)}
              width={300}
            />
          </Grid>

          {/* Support Type */}
          <Grid item xs={12} md={4}>
            <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={0.5}>
              Support Type
            </ArgonTypography>
            <Dropdown
              value={supportType}
              options={["Attendance", "Account", "Payment"]}
              onChange={(e) => setSupportType(e.target.value)}
              width={300}
            />
          </Grid>

          {/* Related To */}
          <Grid item xs={12} md={4}>
            <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={0.5}>
              Support Related to
            </ArgonTypography>
            <Dropdown
              value={relatedTo}
              options={["Student/Parent", "Tutor"]}
              onChange={(e) => setRelatedTo(e.target.value)}
              width={300}
            />
          </Grid>

          {/* Attachments Section */}
          <Grid item xs={12}>
            <ArgonBox mb={1} mt={1}>
              <ArgonTypography variant="subtitle1" fontWeight="medium" color="text" mb={0.5}>
                Attachments
              </ArgonTypography>
            </ArgonBox>
          </Grid>

          {/* Upload Boxes */}
          {[1, 2, 3].map((num) => (
  <Grid item xs={12} md={4} key={num}>
    <ArgonBox
      sx={{
        border: "2px dashed #1976d2",
        borderRadius: "10px",
        p: 1,
        textAlign: "center",
        backgroundColor: "white",
        transition: "all 0.3s ease",
        "&:hover": {
          backgroundColor: "#f8f9fa",
          borderColor: "#1565c0",
        },
      }}
    >
      <CloudUpload sx={{ color: "#1976d2", fontSize: "28px", mb: 1 }} />
      <ArgonTypography
        variant="body2"
        fontWeight="medium"
        color="text"
        mb={0.5}
      >
        Screenshot {num}
      </ArgonTypography>

      <ArgonButton
        component="label"
        variant="outlined"
        size="small"
        sx={{
          borderColor: "#1976d2",
          color: "#1976d2",
          "&:hover": {
            borderColor: "#1565c0",
            backgroundColor: "rgba(21,101,192,0.05)",
          },
        }}
      >
        Choose File
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={(e) => handleFileChange(e, num)}
        />
      </ArgonButton>

      {/* File name show karega agar file select hui hai */}
      {files[num] && (
        <ArgonTypography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 1 }}
        >
          {files[num]}
        </ArgonTypography>
      )}
    </ArgonBox>
  </Grid>
))}


          {/* Status */}
          <Grid item xs={12} md={4}>
            <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={0.5}>
              Status
            </ArgonTypography>
            <Dropdown
              value={status}
              options={["New", "Working", "Resolved"]}
              onChange={(e) => setStatus(e.target.value)}
              width={300}
            />
          </Grid>

          {/* Remark */}
          <Grid item xs={12} md={6}>
            <ArgonTypography variant="body2" fontWeight="medium" color="text" mb={0.5}>
              Additional Remarks
            </ArgonTypography>
            <ArgonInput
              fullWidth
              name="remark"
              placeholder="Any additional comments..."
              multiline
              rows={2}
              variant="outlined"
            />
          </Grid>
        </Grid>

        {/* Actions */}
        <ArgonBox mt={3} display="flex" justifyContent="flex-end" gap={1.5}>
          <ArgonButton variant="outlined" color="primary" size="small">
            Cancel
          </ArgonButton>
          <ArgonButton type="submit" variant="contained" color="primary" size="small">
            Generate Ticket
          </ArgonButton>
        </ArgonBox>
      </form>
    </CardContent>
  </Card>
</ArgonBox>



      <Footer />
    </DashboardLayout>
  )
}

export default AddTicket